import type { ThemeOptions } from '@mui/material/styles'
import type { Contrast } from '../index'
import { createComponents } from './create-components'
import { createPalette } from './create-palette'
import { createShadows } from './create-shadows'

interface Config {
  contrast?: Contrast
}

export const createOptions = (config: Config): ThemeOptions => {
  const { contrast } = config
  const palette = createPalette({ contrast })
  const components = createComponents({ palette })
  const shadows = createShadows()

  return {
    components,
    palette,
    shadows,
  }
}
